import * as React from "react";
import { DebounceInput } from "react-debounce-input";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import {
  AppPermissions,
  Customer,
  useHasPermission,
  useOutsideClick,
} from "../../../../core";
import { useHistory } from "react-router-dom";
import { RouteKeys } from "../../../routes/route-keys";
import { CustomerAvatar } from "../../../../components/render-file/CustomerAvatar";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";

interface ISearchLeadProps {
  onSelect?: (customer: Customer) => void;
  skipRedirection?: boolean;
  wraperClassName: string;
  labelText?: string;
  defaultValue?: string;
  onAddCustomer?: () => void;
  showAddButton?: boolean;
}

const SearchCustomerDebounce: React.FunctionComponent<ISearchLeadProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);

  const [search, setSearch] = React.useState("");
  const [showDropDown, setShowDropDown] = React.useState(false);
  const history = useHistory();

  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    setShowDropDown(false);
  });

  const { data, loading, loaded, reload } = useDataLoader<Customer[]>(
    async (query?: string) => (query ? api.customer.searchCustomer(query) : []),
    [search]
  );

  React.useEffect(() => {
    if (loaded) {
      reload(search);
      setShowDropDown(true);
    }
  }, [search]);

  const onSelect = (customer: Customer) => {
    setShowDropDown(false);
    setSearch("");
    if (customer._id) {
      props.onSelect?.(customer);
    }
    if (!props.skipRedirection) {
      history.push(`${RouteKeys.Lead360View}/${customer._id || ""}`);
    }
  };

  const getCustomerDisplayName = (customer: Customer) => {
    return (
      customer.fullName ||
      customer.name ||
      `${customer?.firstName || ""} ${customer?.lastName || ""}`
    );
  };
  return (
    <div className={props.wraperClassName} key={props.defaultValue} ref={ref}>
      <div className="form-group font-weight-semibold mb-0">
        <label htmlFor="" className="font-sm">
          {props.labelText ?? "Mobile number / Email address"}
        </label>
        <div className="row gutter-5 position-relative">
          <div className="col">
            <div className="row border align-items-center no-gutters">
              <div className="col">
                <DebounceInput
                  className="form-control rounded-sm font-weight-semibold border-0"
                  minLength={3}
                  debounceTimeout={300}
                  onChange={(e) => setSearch(e.target.value)}
                  value={props.defaultValue ?? search}
                  onFocus={() => {
                    if (search.length >= 3) {
                      setShowDropDown(true);
                    }
                  }}
                />
              </div>
              <div className="col-auto">
                <i className="icon-search px-2"></i>
              </div>
            </div>
          </div>
          {showDropDown &&
            loaded &&
            search &&
            ((!!data?.length && !props.showAddButton) ||
              props.showAddButton) && (
              <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-1 ml-1">
                {data?.map((customer) => {
                  return (
                    <div
                      onClick={() => onSelect(customer)}
                      className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
                    >
                      <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                        <CustomerAvatar
                          id={customer?._id}
                          className="m-auto rounded-circle"
                          alt={customer?.name}
                          title={customer?.name}
                          imageUrl={customer?.photo?.location}
                          image={customer?.photo}
                        ></CustomerAvatar>
                      </div>
                      <div className="px-2">
                        <div className="font-normal font-weight-semibold">
                          {getCustomerDisplayName(customer)}
                        </div>
                        <div className="font-sm font-weight-light">
                          {customer.primaryEmail}
                        </div>
                        <div className="font-sm font-weight-light">
                          {customer.primaryPhone}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!data?.length && props.showAddButton && (
                  <div className="custom-dropdown__menu-item align-items-center cursor-pointer py-1 mb-1">
                    <div className="col-md-auto col-12 my-2 py-4 d-flex align-items-center justify-content-center font-normal text-gray-500 font-weight-normal flex-column">
                      <img
                        src={require("../../../../assets/images/no-result.png")}
                        className="img-fluid mb-2"
                        alt="no result found"
                      />
                      No Result Found
                    </div>
                  </div>
                )}
                {props.showAddButton && (
                  <div className="custom-dropdown__menu-item align-items-center cursor-pointer py-1">
                    <div className="col-md-auto col-12 mt-1 p-0">
                      <span
                        onClick={props.onAddCustomer}
                        className="font-normal font-weight-semibold py-2 px-2 h-100 cursor-pointer text-primary d-flex align-items-center"
                      >
                        <i
                          className="font-xxs icon-plus mr-2 p-1 rounded-circle text-primary border border-primary border-width-2 font-weight-bold"
                          style={{ border: "2px solid #4161c8 !important" }}
                        ></i>{" "}
                        Add Customer
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}
          {/* <div className="col-auto">
            <button className="btn btn-primary font-normal px-3 font-weight-semibold">
              GO
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SearchCustomerDebounce;
